
import $ from "jquery";
import Splide from "@splidejs/splide";

$(function () {
    let calendarSlider = document.querySelectorAll(".calendar-slider");
	if (calendarSlider.length > 0) {
		for (let i = 0; i < calendarSlider.length; i++) {
			let calendarSliderElement = calendarSlider[i];
			let calendarSliderDefaultOptions = {
				type: "loop",
				arrows: true,
				pagination: false,
				trimSpace: false,
				perPage: 1,
				perMove: 1,
				gap: "20px",
			};
			let carousel = new Splide(calendarSliderElement, calendarSliderDefaultOptions);
			carousel.mount();
		}
	}


    let day_events = $('.day-events');
    
    day_events.on('click', function(e) {
        e.preventDefault();
        
        $('.calendar-info').empty();

        let date = $(this).children('.event').data("date");

		if(date != undefined) {
			$('.calendar-info').append(
				'<div class="event-header w-100"><div class="date"><p class="event-info__title text-uppercase mb-0">PERFORMANCE SELECTED:</p><h4>' + date + '</h4></div></div>'
			);
		}

        $(this).children('.event').each(function () {
            let availability = $(this).data("availability");
            let url = $(this).data("url");
            let time = $(this).data("time");

			if(availability != undefined && url != undefined && time != undefined) {
				$('.calendar-info').append(
					'<div class="event-info pb-3 pb-lg-5 w-100"><div class="d-flex justify-content-between align-items-center"><div class="extra-info text-start"><div class="time">' + time + '</div><div class="availability"><span class="d-flex align-items-center' + availability + '">' + availability + '</span></div></div><a class="event-url mt-1 mt-lg-0" href="' + url + '" target="_blank">GET TICKETS</a></div></div>'
				);
			}
        });
    })
});

